import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import i18n from 'i18n'

import { ApplicationState } from '@/state/root.models'
import { RestApiService } from '@/services'
import {
  setLoadingFullAction,
  setSnackbarAction,
} from '@/state/ui/global/slices/index.slices'

import { removeEmptyProp } from '@/utils'
import ActionTypes from '../constants'
import {
  GetSportsROCalculatorPayload,
  GetSportsROResponse,
  SportsROState,
} from '../models'

import { SPORTS_RO } from './api.routes'
import { SportsROActions } from '../slices/sports-ro-calculator.slices'

const restApiService: RestApiService = Container.get(RestApiService)

export const getSportsROCalculatorThunk = createAsyncThunk(
  ActionTypes.GET_ALL_SPORTS_RO_CALCULATOR,
  async (payload: GetSportsROCalculatorPayload, thunkAPI) => {
    try {
      const { xlsx, ...rest } = payload
      const { auth } = thunkAPI.getState() as ApplicationState

      if (!xlsx) {
        thunkAPI.dispatch(SportsROActions.setIsloadingAction(true))
      }

      thunkAPI.dispatch(setLoadingFullAction(true))

      restApiService.requestParams = {
        method: 'POST',
        endpoint: SPORTS_RO.SPORTS_RO_CALCULATOR,
        body: removeEmptyProp(rest),
      }

      const response: GetSportsROResponse = await restApiService.sendData(
        auth.brand.siteId.toString(),
        auth.token,
      )

      thunkAPI.dispatch(setLoadingFullAction(false))

      if (response.status && response.status !== 200) {
        const message =
          typeof response.message === 'string'
            ? response.message
            : i18n.t('messages.errorOccurred')

        thunkAPI.dispatch(
          setSnackbarAction({
            message,
            open: true,
            variant:
              response?.status && response?.status !== 200
                ? 'error'
                : 'success',
          }),
        )
      }

      return response
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
      return thunkAPI.rejectWithValue({
        message: error,
        status: error,
      })
    }
  },
)

const getSportsROCalculatorExtraReducer = (
  builder: ActionReducerMapBuilder<SportsROState>,
) => {
  builder.addCase(
    getSportsROCalculatorThunk.fulfilled,
    (state, { payload, meta }) => {
      const { xlsx } = meta?.arg

      state.isLoading = false
      state.sportsRO = xlsx ? state.sportsRO : payload
    },
  )
  builder.addCase(getSportsROCalculatorThunk.rejected, (state) => {
    state.isLoading = false
  })
}

export default getSportsROCalculatorExtraReducer
